import axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'alokasi',
    state: {
        alokasi: [],
    },
    getters: {
        getAlokasi: state => {
            return state.alokasi
        },
    },
    mutations: {
        SET_ALLOCATION: (state, payload) => {
            state.alokasi = payload
        }
    },
    actions: {
        async FETCH_ALLOCATION(store) {
            return await axios({
                method: "get",
                url: ServiceURL + "main/getallocation",
                params: {
                    tlc: store.rootState.user.auth.username
                },
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('SET_ALLOCATION', response.data.data)
            }).catch(err => {
                return err
            });
        },
    }
}